import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { connect } from 'react-redux';
import { hot } from 'react-hot-loader/root';

import moment from 'moment';

import { Dropdown, Typography, Tag } from 'antd';

import { DownOutlined, FormOutlined, EyeOutlined, TeamOutlined, CalendarOutlined } from '@ant-design/icons';

import Overview from '../../components/overview';

import withErrorHandler from '../../../../hoc/withErrorHandler';
import axios from '../../../../shared/axios/axios';
import newAxios from '../../../../shared/axios/new-api-axios';

import { pipelinePagesTypes } from '../../../../shared/constants/enums/pipelinePagesTypes';
import { userTypes } from '../../../../shared/constants/enums';
import { siteUrls } from '../../../../shared/constants/siteUrls';
import { generateColumns, loadSingleBucket, loadData, pipelineDateFormat } from '../../helpers/pipelines-overview-helper';
import { taskPipelineCustomFilterTypes } from '../../../../shared/constants/enums/pipelinePagesTypes';

import * as actions from '../../store/actions';
import * as sharedActions from '../../../../shared/store/actions';

import '../../styles.less';
import { isEmpty } from 'lodash';

let root;

const TasksOverview = ({ rootContainer }) => {
  const [columns, setColumns] = useState(null);
  const [columnsFromBackend, setColumnsFromBackend] = useState(null);
  const [filters, setFilters] = useState(null);
  const [defaultCustomFilters, setDefaultCustomFilters] = useState({
    customFilter: taskPipelineCustomFilterTypes['AllTasks'].key,
    totalItems: 0,
  });

  const userInfo = useSelector((state) => state.shared.userInfo);

  const dispatch = useDispatch();

  const { taskStatuses, taskStatusesLoading, taskPipelinesControlConfig, taskPipelinesControlConfigLoading } = useSelector(
    (state) => state.tasksPipelines,
  );

  useEffect(() => {
    root = rootContainer;

    dispatch(actions.getTaskPipelinesControlConfig());

    dispatch(actions.getTaskStatuses()).then((res) => {
      if (res && res.length) {
        dispatch(sharedActions.getUserInfo());

        const colsFromBackend = generateColumns(res, 'value', true);

        setColumns(colsFromBackend);
        setColumnsFromBackend(colsFromBackend);
      }
    });
  }, []);

  useEffect(() => {
    if (!!columnsFromBackend && !!userInfo) {
      let tempFilters = { customFilter: taskPipelineCustomFilterTypes['AllTasks'].key };

      if (userInfo.userType === userTypes.Agent) {
        tempFilters = { assignedTo: 1, agentIds: [userInfo.userId], customFilter: taskPipelineCustomFilterTypes['AllTasks'].key };
      }

      loadAllData(true, tempFilters);
    }
  }, [columnsFromBackend, userInfo]);

  const loadAllData = async (resetPaging, filters) => {
    if (columnsFromBackend) {
      setFilters(filters);

      const updatedColumns = await loadData(columnsFromBackend, resetPaging, filters, 'getTasks', pipelinePagesTypes.TaskOverview);

      const totalRecords = _.sumBy(Object.values(updatedColumns), (col) => col.totalCount);

      const custFilters = {
        customFilter: filters?.customFilter,
        totalItems: totalRecords,
      };
      setDefaultCustomFilters(custFilters);

      setColumns(updatedColumns);
    }
  };

  const refresh = (filters) => {
    loadAllData(true, filters);
  };

  const handleChangeStatus = (sourceCol, destColumn, item) => {
    const updatedColumns = { ...columns };

    Object.keys(updatedColumns).forEach((columnKey) => {
      if (updatedColumns[columnKey].name === sourceCol.name || updatedColumns[columnKey].name === destColumn.name) {
        updatedColumns[columnKey].loading = true;
      }
    });

    setColumns(updatedColumns);

    dispatch(actions.changeTaskStatus(item.id, destColumn.status)).then(() => {
      handleLoadSingleBucketData(destColumn, true);
      handleLoadSingleBucketData(sourceCol, true);
    });
  };

  const handleLoadSingleBucketData = async (column, resetPage) => {
    const updatedColumns = await loadSingleBucket(columns, column, resetPage, filters, 'getTasks', pipelinePagesTypes.TaskOverview);

    setColumns(updatedColumns);
  };

  const renderBucketItem = (item) => {
    return (
      <div className="pipeline-item">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
          <span title={'Insured'} className="text-ellipsis">
            {item.insured && item.insured.name ? (
              <a
                title={item.insured.name.trim()}
                href={siteUrls.getTruckingCompanyDetailsUrl(taskPipelinesControlConfig?.isMomentumEnabled, item.insured.id, item.insured.type)}
              >
                {item.insured.name.trim()}
              </a>
            ) : (
              'N/A'
            )}
          </span>

          {renderActionsMenu(item.id)}
        </div>

        {!!item.ticketTitleFormatted ? (
          <p style={{ margin: '5px 0', fontSize: '12px' }}>
            <Typography.Text type="secondary">{item.ticketTitleFormatted}</Typography.Text>
          </p>
        ) : null}

        <div title={'Assigned agents'} style={{ margin: '5px 0', fontSize: '12px' }}>
          <TeamOutlined style={{ marginRight: '5px' }} />
          {item.assignedAgents && item.assignedAgents.length
            ? item.assignedAgents.map((agent, index) => {
                return (
                  <span key={agent.id}>
                    <a href={siteUrls.getAgentDetailsUrl(taskPipelinesControlConfig?.isMomentumEnabled, agent.id)}>
                      {`${agent.firstName} ${agent.lastName}`.trim()}
                    </a>
                    {item.assignedAgents.length - 1 !== index ? ', ' : ' '}
                  </span>
                );
              })
            : 'N/A'}
        </div>

        {!!item.dueDate ? (
          <div title={'Due date'} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '5px 0', fontSize: '11px', alignItems: 'center' }}>
            <CalendarOutlined style={{ marginRight: '5px' }} />
            <Typography.Text type="secondary">{moment(item.dueDate).format(pipelineDateFormat)}</Typography.Text>
          </div>
        ) : null}

        {item.tags && item.tags.length
          ? item.tags.map((tag) => {
              const existDescription = !isEmpty(tag.description);
              const tagTitle =
                (existDescription ? tag.description : '') +
                (!isEmpty(tag.changeDate)
                  ? (existDescription ? ' ( Applied: ' : 'Applied: ') +
                    moment(tag.changeDate).format(pipelineDateFormat) +
                    (existDescription ? ' ) ' : '')
                  : '');

              return (
                <Tag color={tag.color} key={tag.id} title={tagTitle} style={{ marginRight: '5px', marginTop: '5px' }}>
                  {tag.name}
                </Tag>
              );
            })
          : null}
      </div>
    );
  };

  const renderActionsMenu = (itemId) => {
    const menu = [
      {
        key: itemId + 1,
        label: (
          <a href={siteUrls.getTaskEditUrl(taskPipelinesControlConfig?.isMomentumEnabled, itemId)}>
            <FormOutlined style={{ marginRight: '8px' }} />
            Edit
          </a>
        ),
      },
      {
        key: itemId + 2,
        label: (
          <a href={siteUrls.getTaskDetailsUrl(taskPipelinesControlConfig?.isMomentumEnabled, itemId)}>
            <EyeOutlined style={{ marginRight: '8px' }} />
            Details
          </a>
        ),
      },
    ];

    return (
      <Dropdown menu={{ items: menu }} trigger={['click']} getPopupContainer={rootContainer} placement="bottom">
        <DownOutlined style={{ fontSize: '10px' }} />
      </Dropdown>
    );
  };

  return (
    <Overview
      configuratorEnabled={false}
      columns={columns}
      renderBucketItem={renderBucketItem}
      type={pipelinePagesTypes.TaskOverview}
      userInfo={userInfo}
      statuses={taskStatuses}
      customFiltersData={defaultCustomFilters}
      isLoading={taskStatusesLoading || taskPipelinesControlConfigLoading}
      refresh={refresh}
      changeStatus={handleChangeStatus}
      loadSingleBucketData={handleLoadSingleBucketData}
      rootContainer={rootContainer}
      fetchData={loadAllData}
      isMomentumEnabled={taskPipelinesControlConfig?.isMomentumEnabled}
      canViewOnlyAssigned={taskPipelinesControlConfig?.canViewOnlyAssigned}
      showTotals={true}
    />
  );
};

export default connect(null, null)(hot(withErrorHandler(TasksOverview, axios, root, newAxios)));
